/* eslint-disable react/jsx-key */
import { useSelector } from 'react-redux'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { LocalDate } from '@/components/LocalDate'
import { getOldOrderLines } from '@/ducks/hardwareReducer'

import './old-order-lines.scss'

const OldOrderLines = () => {
  const oldOrderLines = useSelector(getOldOrderLines)

  if (oldOrderLines.length === 0) return null

  return (
    <div className="old-order-lines">
      <h3>Bestilt tidligere</h3>

      <table>
        <tbody>
          {/* @ts-ignore */}
          {oldOrderLines.map(row => (
            <tr>
              <td className="date">
                <LocalDate date={row.order_date} />
              </td>
              <td className="name">{row.product_name}</td>
              <td className="amount number">
                <FormattedNumberWithCurrency amount={row.amount_sum} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default OldOrderLines
